import { useStoreActions } from "../../../../store/store-context";
import { useOverlayContext } from 'seagull';
import { BulkBillingModalTestIds } from "../BulkBillingModal";
import { ErrorResponse, ServerError } from "../../../../infra/ErrorResponse";
import { useMutationState } from "../../../../hooks/reactQuery/useMutationState";
import { useRef, useState } from 'react';
import { BillClientsResultsResponseType } from "../../../../types/api/billing/bulk/bill-clients";
export const useBulkBillClients = _ref => {
  let {
    onSuccess: _onSuccess,
    onError: _onError
  } = _ref;
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    showSuccessToast,
    showErrorToast
  } = useOverlayContext();
  const isJobInProgress = useRef(false);
  const [progress, setProgress] = useState(undefined);
  const {
    mutate,
    isLoading,
    data: billResults,
    isIdle,
    reset
  } = useMutationState({
    mutationFn: async bulkUploadId => {
      if (!bulkUploadId) {
        return null;
      }
      logBI(18704);
      await api.billing.bulk.billClients(bulkUploadId);
      isJobInProgress.current = true;
      let _progress;
      while (isJobInProgress.current) {
        const jobResponse = await api.billing.bulk.getBillClientsResult(bulkUploadId);
        if (jobResponse.type === BillClientsResultsResponseType.InProgress) {
          _progress = {
            completed: jobResponse.inProgress.invoicesCompletedCount,
            total: jobResponse.inProgress.totalInvoicesCount
          };
          setProgress(_progress);
        } else {
          var _progress2, _progress3;
          isJobInProgress.current = false;
          if (jobResponse.type === BillClientsResultsResponseType.Succeeded && (_progress2 = _progress) !== null && _progress2 !== void 0 && _progress2.total && ((_progress3 = _progress) === null || _progress3 === void 0 ? void 0 : _progress3.total) > 0) {
            var _progress4, _progress5;
            setProgress({
              completed: (_progress4 = _progress) === null || _progress4 === void 0 ? void 0 : _progress4.total,
              total: (_progress5 = _progress) === null || _progress5 === void 0 ? void 0 : _progress5.total
            });
            return jobResponse;
          }
          setProgress(undefined);
          return jobResponse;
        }
      }
      return null;
    },
    onSuccess: data => {
      if (!data) {
        return;
      }
      if ((data === null || data === void 0 ? void 0 : data.type) !== BillClientsResultsResponseType.Failed) {
        _onSuccess === null || _onSuccess === void 0 || _onSuccess();
        logBI(18705);
        showSuccessToast('Clients billed successfully', BulkBillingModalTestIds.SuccessToast());
      }
    },
    onError: e => {
      try {
        resetBulkBillClients();
        _onError === null || _onError === void 0 || _onError();
        const error = new ErrorResponse(e);
        if (error.hasServerError(ServerError.BulkBillAlreadyInProgress)) {
          showErrorToast('A bulk billing process is already in progress. Please wait a few minutes and try again', BulkBillingModalTestIds.ErrorToast());
        } else {
          showErrorToast('Something went wrong, please contact support', BulkBillingModalTestIds.ErrorToast());
        }
      } catch (e) {
        showErrorToast('Something went wrong, please contact support', BulkBillingModalTestIds.ErrorToast());
      }
    }
  });
  const resetBulkBillClients = () => {
    reset();
    setProgress(undefined);
    isJobInProgress.current = false;
  };
  return {
    billClients: mutate,
    billResults,
    progress,
    isLoading: isLoading || (billResults === null || billResults === void 0 ? void 0 : billResults.type) === BillClientsResultsResponseType.Succeeded,
    reset: resetBulkBillClients,
    wasBillClientsClicked: !isIdle
  };
};